
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ColorCodeTriangle from "@/components/scheduler/ColorCodeTriangle.vue";
  import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import Tooltip from "@/components/common/Tooltip.vue";

  import { Contractor } from "@/generated/graphql";
  import ProjectViewActivity from "@/entities/scheduler/ProjectViewActivity";
  import getFullName from "@/helpers/getFullName";
  import getAvatarPadding from "@/helpers/scheduler/getAvatarPadding";
  import TooltipVariants from "@/entities/TooltipVariants";

  @Component({
    components: {
      ColorCodeTriangle,
      SchedulerItemAvatar,
      UiButton,
      Tooltip,
    }
  })
  export default class ProjectViewActivityItem extends Vue {
    @Prop({ type: Object, required: true}) readonly activity!: ProjectViewActivity;

    TooltipVariants = TooltipVariants;

    get isNewlyCreatedItem(): boolean {
      return Boolean(!this.activity.entityInfo);
    }

    get contractor(): Contractor | undefined {
      const contractor = this.activity.entityInfo.contractor;
      if (!contractor || contractor.deleted) {
        return undefined;
      }
      return contractor;
    }

    get activityName(): string {
      return this.activity.entityInfo?.name || "";
    }

    get contractorAvatar(): string {
      return this.contractor?.user?.avatar|| "";
    }

    get contractorName(): string {
      const givenName = this.contractor?.user.given_name || "";
      const familyName = this.contractor?.user.family_name || "";
      return getFullName(givenName, familyName);
    }

    get colorCode(): string {
      if (!this.contractor) {
        return "danger";
      }
      return "";
    }

    get tooltipTitle(): string {
      if (!this.contractor) {
        return "Task does not have a contractor";
      }
      return "";
    }

    get avatarsPadding(): string {
      return getAvatarPadding(this.colorCode);
    }
  }
